import styled from "styled-components";

export const SPContainer = styled.div`
	display: flex;
	flex-direction: column;
	flex: 1;
`;
